export default __webpack_public_path__ + "static/media/k3.28f1a77f.png";